import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';
import '@/js/modules/jquery_datepicker_defaults';

onPageLoad(() => {
  if ($('body').is('#dashboard')) {
    function appendLoading($containerEl) {
      $containerEl.append(
        '<div class="dashboard-loading-message"><div class="dashboard-loading-message__spinner"></div>Populating data...</div>'
      );
    }

    function removeLoading($containerEl) {
      $containerEl.find('.dashboard-loading-message').remove();
    }

    function populateNumbersReports() {
      $('.overview-section[data-numbers-reports="true"]').each((_i, el) => {
        const $container = $(el).find('.overview-section__data-container');
        $container.addClass('hide');
        $container.find('.overview-section__summary').addClass('hide');
        appendLoading($(el));
      });

      const timeFilter = $('.filter-list__dropdown-trigger').attr('data-time-filter');
      const customRangeFrom = $('.filter-list__dropdown-trigger').attr('data-custom-range-from');
      const customRangeTo = $('.filter-list__dropdown-trigger').attr('data-custom-range-to');
      $.get(
        '/dashboard/xhr_numbers_reports',
        {
          time_filter: timeFilter,
          custom_range_from: customRangeFrom,
          custom_range_to: customRangeTo,
        },
        (currentData) => {
          const reports = Object.keys(currentData);

          reports.forEach((report, _i) => {
            const $section = $(`.overview-section[data-report=${report}]`);
            const $container = $section.find('.overview-section__data-container');
            $container.find('.overview-section__value').text(currentData[report]);
            removeLoading($section);
            $container.removeClass('hide');
          });

          // no previous data for `All Time` & custom range
          if (timeFilter !== 'all_time' && timeFilter !== 'custom') {
            $('.overview-section[data-numbers-reports="true"]').each((_i, el) => {
              appendLoading($(el).find('.overview-section__data-container'));
            });

            $.get(
              '/dashboard/xhr_numbers_reports',
              {
                time_filter: timeFilter,
                previous: true,
                custom_range_from: customRangeFrom,
                custom_range_to: customRangeTo,
              },
              (previousData) => {
                reports.forEach((report, _i) => {
                  const $section = $(`.overview-section[data-report=${report}]`);
                  const $container = $section.find('.overview-section__data-container');

                  let percentage = 0;
                  let cNumber = currentData[report];
                  let pNumber = previousData[report];
                  if (report === 'avg_budget') {
                    cNumber = parseFloat(cNumber.replace(/[^0-9.-]+/g, ''));
                    pNumber = parseFloat(pNumber.replace(/[^0-9.-]+/g, ''));
                  }
                  if (pNumber > 0) {
                    percentage = (((cNumber - pNumber) / pNumber) * 100).toFixed(2);
                  }
                  const $pecentageEl = $container.find('.overview-section__percentage');
                  $pecentageEl
                    .removeClass('overview-section__percentage--positive')
                    .removeClass('overview-section__percentage--negative')
                    .removeClass('overview-section__percentage--neutral')
                    .removeClass('overview-section__percentage--positive-reversed')
                    .removeClass('overview-section__percentage--negative-reversed');
                  if (percentage > 0) {
                    $pecentageEl.text(`${Math.abs(percentage)}%`);
                    $pecentageEl.addClass('overview-section__percentage--positive');
                    if (report === 'avg_boards_per_project') {
                      $pecentageEl.addClass('overview-section__percentage--positive-reversed');
                    }
                  } else if (percentage < 0) {
                    $pecentageEl.text(`${Math.abs(percentage)}%`);
                    $pecentageEl.addClass('overview-section__percentage--negative');
                    if (report === 'avg_boards_per_project') {
                      $pecentageEl.addClass('overview-section__percentage--negative-reversed');
                    }
                  } else {
                    $pecentageEl.text(pNumber === 0 ? 'No data available' : 'No change');
                    $pecentageEl.addClass('overview-section__percentage--neutral');
                  }
                  const timeFilterText = $('.filter-list__dropdown-trigger-text')
                    .text()
                    .replaceAll('Last', '')
                    .replaceAll('This', '')
                    .trim()
                    .toLowerCase();
                  $container
                    .find('.overview-section__over-previous')
                    .text(
                      `${
                        percentage === 0 && pNumber === 0 ? 'for' : 'over'
                      } the previous ${timeFilterText}`
                    );
                  removeLoading($container);
                  $container.find('.overview-section__summary').removeClass('hide');
                });
              }
            );
          }
        }
      );
    }

    function populateDetailedBreakdown() {
      $('.detailed-breakdown-section').each((_i, el) => {
        const $section = $(el);
        const $tbody = $section.find('tbody');

        if ($tbody.attr('data-action')) {
          $tbody.html('');
          appendLoading($section);

          const timeFilter = $('.filter-list__dropdown-trigger').attr('data-time-filter');
          const customRangeFrom = $('.filter-list__dropdown-trigger').attr(
            'data-custom-range-from'
          );
          const customRangeTo = $('.filter-list__dropdown-trigger').attr('data-custom-range-to');
          $.get(
            `/dashboard/xhr_${$tbody.attr('data-action')}`,
            {
              time_filter: timeFilter,
              custom_range_from: customRangeFrom,
              custom_range_to: customRangeTo,
            },
            (res) => {
              removeLoading($section);
              if (res.html && res.html.includes('detailed-breakdown-section__tr')) {
                $tbody.append(res.html);
              } else {
                const timeFilterText = $('.filter-list__dropdown-trigger-text')
                  .text()
                  .trim()
                  .toLowerCase();
                $tbody.append(
                  `<tr class="detailed-breakdown-section__tr detailed-breakdown-section__tr--no-data"><td class="detailed-breakdown-section__td" colspan="3">No data available for ${timeFilterText}</td></tr>`
                );
              }
            }
          );
        }
      });
    }

    function populateData() {
      populateNumbersReports();
      populateDetailedBreakdown();
    }

    document.addEventListener('click', (e) => {
      const $target = $(e.target);
      const className = $target.attr('class') || '';
      if ($target.closest('.ui-datepicker').length || className.includes('datepicker')) {
        return;
      }
      if (
        $('.filter-list--dashboard')
          .children('.filter-list__item')
          .hasClass('filter-list__item--open') &&
        !$($target).closest('.filter-list__item').length
      ) {
        $('.filter-list--dashboard')
          .children('.filter-list__item')
          .removeClass('filter-list__item--open');
        hideDatePicker();
        hideDateForm();
      }
    });

    function initDatePicker() {
      $('.field--date').datepicker();
    }

    function hideDatePicker() {
      $('.field--date').each((_, el) => $(el).datepicker('hide'));
    }

    function showDateForm() {
      $('.filter-dropdown--date-form').show();
    }

    function hideDateForm() {
      $('.filter-dropdown--date-form').hide();
    }

    $('.filter-dropdown__item--date-custom').on('click', (e) => {
      e.stopPropagation();
      if ($(e.target).is('.filter-dropdown__item--date-custom')) {
        showDateForm();
      }
    });

    $('.filter-dropdown__item--dashboard').on('click', (e) => {
      const $el = $(e.target);
      if (
        $el.is('.filter-dropdown__item--date-custom') ||
        !$el.is('.filter-dropdown__item--dashboard')
      ) {
        return;
      }

      $('#report_time_filter').val($el.attr('data-time-filter'));
      $('#csv_time_filter').val($el.attr('data-time-filter'));
      $('.filter-list__dropdown-trigger').attr('data-time-filter', $el.attr('data-time-filter'));
      $('.filter-list__dropdown-trigger-text').text($el.text().trim());
      $('.filter-list__dropdown-trigger').click();
      populateData();
    });

    $('.s-button--submit-date-form').on('click', (e) => {
      const $startDateField = $('.field--date-start');
      const $endDateField = $('.field--date-end');
      const startDateVal = $startDateField.datepicker('getDate');
      const endDateVal = $endDateField.datepicker('getDate');
      const padDate = (val) => val.toString().padStart(2, '0');
      const formatDate = (dateVal) =>
        `${padDate(dateVal.getMonth() + 1)}/${padDate(dateVal.getDate())}/${padDate(
          dateVal.getFullYear()
        )}`;
      if (startDateVal && endDateVal) {
        $('#report_time_filter').val('custom');
        $('#csv_time_filter').val('custom');
        $('#report_custom_range_from').val(formatDate(startDateVal));
        $('#report_custom_range_to').val(formatDate(endDateVal));
        $('#csv_custom_range_from').val(formatDate(startDateVal));
        $('#csv_custom_range_to').val(formatDate(endDateVal));

        $('.filter-list__dropdown-trigger')
          .attr('data-time-filter', 'custom')
          .attr('data-custom-range-from', formatDate(startDateVal))
          .attr('data-custom-range-to', formatDate(endDateVal));
        $('.filter-list__dropdown-trigger-text').text(
          `${$startDateField.val()} - ${$endDateField.val()}`
        );
        $('.filter-list__dropdown-trigger').click();
        populateData();
      }
    });

    $('.filter-list__dropdown-trigger').on('click', (e) => {
      e.preventDefault();
      if ($(e.target).is('.filter-list__dropdown-trigger')) {
        hideDatePicker();
        hideDateForm();
      }
    });

    $(document).ready(() => {
      initDatePicker();

      populateData();
    });
  }
});
